import {
  BUTTON_STATE_ATTRIBUTE,
  PLATFORM_BUTTON_DIV,
  STATUS_ATTRIBUTE,
  elements,
} from '../resources';
import { getCopy } from '../helpers';
import * as actions from '../actions';
import { getState } from '../core';
import { bookmarkIcon } from '../resources';

const { allBookmarkButtons } = elements;

// set classes and attributes for tracking and styling
const setButtonAttributes = (
  articleState: StateType['article'] = 'unknown',
  status: StateType['status'] = 'error'
) => {
  allBookmarkButtons.forEach((button) => {
    window.requestAnimationFrame(() => {
      button.setAttribute(BUTTON_STATE_ATTRIBUTE, articleState.toString());
      button.setAttribute(STATUS_ATTRIBUTE, status.toString());
    });
  });

  allBookmarkButtons.forEach((button) => {
    window.requestAnimationFrame(() => {
      if (articleState === 'not-logged-in')
        setButtonTitle(button, 'PLEASE_LOG_IN');
      if (articleState === 'bookmarked')
        setButtonTitle(button, 'CLICK_TO_UNBOOKMARK');
      if (articleState === 'not-bookmarked')
        setButtonTitle(button, 'CLICK_TO_BOOKMARK');
      if (status === 'error') {
        setButtonTitle(button, 'ERROR');
      }
    });
  });
};

const setButtonTitle = (button: Element, key: string) => {
  const { brandName } = getState();
  button.setAttribute(
    'title',
    getCopy(brandName!, 'article', 'buttonInfo', key)
  );
};

const handleButtonClick = () => {
  const { sessionLoggedIn, article } = getState();

  if (sessionLoggedIn) {
    // do the inverse of current articleIsBookmarked
    if (article === 'not-bookmarked') {
      actions.addBookmark();
    } else if (article === 'bookmarked') {
      actions.removeBookmark();
    }
  } else {
    actions.showModal();
  }
};

// Render should only react to localstorage and update itself.
const renderButton = (init = false) => {
  const { sessionLoggedIn, article, status } = getState();

  setButtonAttributes(article, status);

  if (init) {
    if (!allBookmarkButtons?.length) {
      throw new Error(
        `Could not find a bookmark container div with ${PLATFORM_BUTTON_DIV} `
      );
    }
    allBookmarkButtons.forEach((button) => {
      button.insertAdjacentHTML('afterbegin', bookmarkIcon);
      button.addEventListener('click', handleButtonClick);
    });
    if (sessionLoggedIn) {
      actions.getDataForArticlePage();
    }
  }
};

export { allBookmarkButtons, renderButton };
